import Box from '@zenbusiness/zui/Box';
import DialogContent from '@zenbusiness/zui/DialogContent';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

export const DialogContentStyled = styled(DialogContent)(({ theme }) => ({
  padding: '24px 0 24px 0',
  [theme.breakpoints.up('md')]: {
    padding: '40px 0 40px 0'
  }
}));

export const Wrapper = styled(Stack)(({ theme }) => ({
  gridColumn: '1 / 5',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '4 / 10'
  }
}));

export const Circle = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  height: '32px',
  width: '32px',
  backgroundColor: theme.palette.background.green.main,
  padding: '8px',
  flex: 'none'
}));

export const BoxStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  border: `1px solid ${theme.palette.border.main}`,
  borderRadius: '16px',
  padding: '24px',
  [theme.breakpoints.up('md')]: {
    padding: '32px',
    gap: '32px'
  }
}));
